import { domain } from "@relode/core";
import {
    SkillJobQualificationResponse,
    LicenseJobQualificationResponse,
    EducationJobQualificationResponse,
    CustomYesNoJobQualificationResponse,
    CustomTextJobQualificationResponse,
    JobQualificationsResponse,
} from "../controllers/jobs";

export const convertCustomYesNoJobQualificationResponse = (
    res: CustomYesNoJobQualificationResponse
) => {
    const qual: domain.CustomYesNoJobQualification = {
        id: res.jobQualificationId,
        isRequired: res.isRequired,

        qualification: domain.Qualification.fromId(res.qualificationId),
        customText: res.customQualificationText,
        customYesNoChoiceId: res.customYesNoChoiceId,
        yesNoTag: domain.YesNoTag.fromId(res.yesNoTagId),
    };

    return qual;
};

export const convertCustomTextJobQualificationResponse = (
    res: CustomTextJobQualificationResponse
) => {
    const qual: domain.CustomTextJobQualification = {
        id: res.jobQualificationId,
        isRequired: res.isRequired,

        qualification: domain.Qualification.fromId(res.qualificationId),
        customText: res.customQualificationText,
    };

    return qual;
};


export const convertSkillJobQualificationResponse = (
    res: SkillJobQualificationResponse
): domain.SkillJobQualification => {
    const qual: domain.SkillJobQualification = {
        id: res.jobQualificationId,
        isRequired: res.isRequired,
        qualification: domain.Qualification.fromId(res.qualificationId),
        yearsExperience: domain.YearsExperience.fromId(
            res.yearsOfExperienceTagId
        ),
        skills: res.skillChoices.map(c => ({
            choiceId: c.skillChoiceId,
            skillTagId: c.skillTagId,
            skillTagName: c.skillTagName,
            skillCustomText: c.skillCustomText,
        })),
    };
    return qual;
};

export const convertLicenseJobQualificationResponse = (
    res: LicenseJobQualificationResponse
): domain.LicenseJobQualification => {
    const qual: domain.LicenseJobQualification = {
        id: res.jobQualificationId,
        isRequired: res.isRequired,
        qualification: domain.Qualification.fromId(res.qualificationId),
        licenses: res.licenseChoices.map(c => ({
            choiceId: c.licenseChoiceId,
            licenseTagId: c.licenseTagId,
            licenseTagName: c.licenseTagName,
            licenseCustomText: c.licenseCustomText,
            stateTagId: c.stateTagId,
            stateTagName: c.stateTagName,
        })),
    };
    return qual;
};

export const convertLicenseAnyOfJobQualificationResponse = (
    res: LicenseJobQualificationResponse
): domain.LicenseAnyOfJobQualification => {
    const qual: domain.LicenseAnyOfJobQualification = {
        id: res.jobQualificationId,
        isRequired: res.isRequired,
        qualification: domain.Qualification.fromId(res.qualificationId),
        licenses: res.licenseChoices.map(c => ({
            choiceId: c.licenseChoiceId,
            licenseTagId: c.licenseTagId,
            licenseTagName: c.licenseTagName,
            licenseCustomText: c.licenseCustomText,
            stateTagId: c.stateTagId,
            stateTagName: c.stateTagName,
        })),
    };
    return qual;
};

export const convertEducationJobQualificationsResponse = (
    res: EducationJobQualificationResponse
): domain.EducationJobQualification => {
    const qual: domain.EducationJobQualification = {
        id: res.jobQualificationId,
        isRequired: res.isRequired,
        qualification: domain.Qualification.fromId(res.qualificationId),
        education: {
            educationChoiceTagId: res.educationTagId,
            educationChoiceTagName: res.educationTagName,
            educationChoiceId: res.educationChoiceId,
        },
    };

    return qual;
};

export const convertJobQualificationsResponse = (
    response: JobQualificationsResponse
): domain.JobQualifications => {
    if (!response) return null;

    const jobQualifications: domain.JobQualifications = {
        educationJobQualifications: response.educationJobQualifications?.map(
            q => convertEducationJobQualificationsResponse(q)
        ),
        skillJobQualifications: response?.skillJobQualifications?.map(x =>
            convertSkillJobQualificationResponse(x)
        ),
        skillAnyOfJobQualifications: response?.skillAnyOfJobQualifications?.map(
            x => convertSkillJobQualificationResponse(x)
        ),
        licenseJobQualifications: response?.licenseJobQualifications?.map(x =>
            convertLicenseJobQualificationResponse(x)
        ),
        licenseAnyOfJobQualifications:
            response?.licenseAnyOfJobQualifications?.map(x =>
                convertLicenseAnyOfJobQualificationResponse(x)
            ),
        customYesNoJobQualifications:
            response?.customYesNoJobQualifications?.map(x =>
                convertCustomYesNoJobQualificationResponse(x)
            ),
        customTextJobQualifications: response?.customTextJobQualifications?.map(
            x => convertCustomTextJobQualificationResponse(x)
        ),
    };
    return jobQualifications;
};
